import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Phone, Mail, MapPin, Loader2 } from 'lucide-react';
import { useLocations } from '../happyspace-restaurant-sdk';
import { BRAND_NAME, BRAND_DOMAIN, LOGO_URL } from '../config/brand';

export default function Footer() {
  const { locations, nearestLocation, loading } = useLocations();
  const displayLoc = nearestLocation || locations[0];

  return (
    <footer className="bg-[#451A03] text-white pt-20 pb-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={LOGO_URL} 
                alt={`${BRAND_NAME} Logo`} 
                className="h-14 w-auto object-contain hover:opacity-90 transition-opacity"
                data-hs-id="footer-logo"
              />
            </Link>
            <p className="text-orange-100/60 mb-8">
              Bringing authentic Mediterranean and Afghan flavors to the heart of Dallas-Fort Worth.
            </p>
            <div className="flex gap-4">
              <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-[#D97706] transition-colors"><Instagram className="w-5 h-5" /></a>
              <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-[#D97706] transition-colors"><Facebook className="w-5 h-5" /></a>
              <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-[#D97706] transition-colors"><Twitter className="w-5 h-5" /></a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-4 text-orange-100/60">
              <li><Link to="/" className="hover:text-[#D97706]">Home</Link></li>
              <li><Link to="/menu" className="hover:text-[#D97706]">Our Menu</Link></li>
              <li><Link to="/locations" className="hover:text-[#D97706]">Locations</Link></li>
              <li><Link to="/checkout" className="hover:text-[#D97706]">Order Now</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Locations</h4>
            {loading ? (
              <div className="flex items-center gap-2 text-orange-100/60">
                <Loader2 className="w-4 h-4 animate-spin" /> Loading…
              </div>
            ) : locations.length > 0 ? (
              <ul className="space-y-3 text-orange-100/60">
                {locations.slice(0, 4).map((loc, i) => (
                  <li key={loc._id || i}>
                    <Link to="/locations" className="hover:text-[#D97706]">{loc.name}</Link>
                  </li>
                ))}
                {locations.length > 4 && (
                  <li><Link to="/locations" className="text-[#D97706] font-medium hover:underline">View all</Link></li>
                )}
              </ul>
            ) : (
              <p className="text-orange-100/60">View our locations</p>
            )}
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contact</h4>
            {loading ? (
              <div className="flex items-center gap-2 text-orange-100/60">
                <Loader2 className="w-4 h-4 animate-spin" /> Loading…
              </div>
            ) : displayLoc ? (
              <ul className="space-y-4 text-orange-100/60">
                {displayLoc.address && (
                  <li className="flex items-start gap-3">
                    <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                    <span>{displayLoc.address}</span>
                  </li>
                )}
                {displayLoc.phone && (
                  <li className="flex items-center gap-3">
                    <Phone className="w-5 h-5 flex-shrink-0" />
                    <a href={`tel:${displayLoc.phone.replace(/\D/g, '')}`} className="hover:text-[#D97706]">{displayLoc.phone}</a>
                  </li>
                )}
                <li className="flex items-center gap-3">
                  <Mail className="w-5 h-5 flex-shrink-0" />
                  <a href={`mailto:hello@${BRAND_DOMAIN}`} className="hover:text-[#D97706]">hello@{BRAND_DOMAIN}</a>
                </li>
                {displayLoc.hours && (
                  <li className="pt-4">
                    <div className="border border-orange-100/20 p-4 rounded-xl">
                      <p className="text-sm font-bold text-[#D97706] mb-1">Hours</p>
                      <p className="text-xs">{displayLoc.hours}</p>
                    </div>
                  </li>
                )}
              </ul>
            ) : (
              <ul className="space-y-4 text-orange-100/60">
                <li className="flex items-center gap-3"><Phone className="w-5 h-5" /> (972) 555-0123</li>
                <li className="flex items-center gap-3"><Mail className="w-5 h-5" /> hello@{BRAND_DOMAIN}</li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}